// @flow
import type {Element} from 'react'
import React from 'react'
import styles from './index.scss'

type Props = $ReadOnly<{
  count: number,
}>

function NotificationBadge({count}: Props): Element<"div"> {
  return (
    <div className={styles.notificationBadge}>
      <turbo-frame id="inbox-notifications-badge-count">
        {count}
      </turbo-frame>
    </div>
  )
}

export default NotificationBadge
